// TODO: split this hooks to modules that make sense eg fetchApi/uiEffects/...

import { useEffect } from 'react';

export const usePageChangeTo = (
    screenName,
    {
        change_hash = false,
        hide_header = false,
        hide_footer = false,
        go_back = false,
    } = {}
) => {
    useEffect(() => {
        Mobi2Go.UI.page.change(screenName, go_back, undefined, undefined, {
            change_hash,
            hide_header,
            hide_footer,
        });
    }, [change_hash, go_back, hide_footer, hide_header, screenName]);
};

export const usePageTitle = (name, title) => {
    useEffect(() => {
        Mobi2Go.UI.page.setTitle(name, title);
    }, [name, title]);
};

export const useHideElementsByQuerySelector = (querySelectors = []) => {
    useEffect(() => {
        const elements = querySelectors
            .map(e => document.querySelector(e))
            .filter(e => !!e);

        elements.forEach(e => {
            e.style.visibility = 'hidden';
        });

        return () => {
            elements.forEach(e => {
                e.style.visibility = 'visible';
            });
        };
    }, [querySelectors]);
};

export const useHideHeaderAndCheckout = () => {
    useHideElementsByQuerySelector([
        '[data-page-header]',
        '[data-view="order-checkout"]',
    ]);
};

export const getPlatform = () => Mobi2Go.app.getPlatform();
export const pageBack = () => Mobi2Go.UI.page.back();
export const progressUiForward = () => Mobi2Go.UI.trigger('progressForward');
